import React, { useState, useEffect, useRef } from "react";
import * as XLSX from "xlsx";
import { Link, useHistory } from "react-router-dom";
import { KTSVG, toAbsoluteUrl } from "../../../_metronic/helpers";
import air from "../../../Assets/Plane icon.png";
import ship from "../../../Assets/Ship icon.png";
import Truck from "../../../Assets/Truck icon.png";
import jsPDF from "jspdf";
import "jspdf-autotable";
import html2canvas from "html2canvas";
import { BookingDrop } from "./BookingDrop";
import loadingimage from "../../../Assets/loading-buffering1.gif";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { FaCheck, FaTimes } from "react-icons/fa";
import BookingEdit from "./BookingEdit";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import moment from "moment";
import { auto } from "@popperjs/core";

type BookingDetail = {
  id: number;
  booking_value: string;
  consignor_payment_status: string;
  payment_status: string;
  booking_id: string;
  consignor: string;
  consignee: string;
  total_quantity: number;
  shipment_mode: string;
  shipment_status: string;
  who_paid: string;
  booking_mode: string;
  consignor_address: string;
  consignee_address: string;
  nrml_payment_quantity: number;
  nrml_quantity_price: number;
  small_box_quantity: number;
  large_box_quantity: number;
  medium_box_quantity: number;
  large_unit_price: number;
  small_unit_price: number;
  medium_unit_price: number;
  total_pieces_price: number;
  total_cbm_price: number;
  nrml_qty_total_price: number;
  split_total_price: number;
  total_pieces: number;
  piece_value: number;
  cbm_value: number;
  cbm_price: number;
  invoice_percentage: number;
  total_invoice_price: number;
  splits: SplitDetail[];
  box_type: string;
  items: Array<{
    details: string;
    booking_id: string;
    unit_price: number;
    total_amount: number;
    total_price: number;
    total_quantity: number;
    // Add other properties as needed
  }>;
  description: string;
  payment_mode: string;
  invoice_value: number;
  notes: string;
  created_at: string;
  total_amount: number;
  unit_price: number;
  total_price: number;
};

type SplitDetail = {
  split_id: string;
  shipment_id: string;
  consignor: string;
  booking_value: string;
  customer_id: string;
  consignor_address: string;
  consignee: string;
  consignee_address: string;
  total_quantity: number;
  booking_id: string;
  main_booking_id: string;
  small_journey_quantity: number;
  medium_journey_quantity: number;
  large_journey_quantity: number;
  shipment_status: string;
  who_paid: string;
  nrml_payment_quantity: number;
  small_box_quantity: number;
  large_box_quantity: number;
  medium_box_quantity: number;
  created_at: string;
  // Add other fields as necessary
};

type Props = {
  className: string;
};

const BookingTable: React.FC<Props> = ({ className }) => {
  const [bookingDetails, setBookingDetails] = useState<BookingDetail[]>([]);
  const [selectedBookings, setSelectedBookings] = useState<BookingDetail[]>([]);
  const [error, setError] = useState<string | null>(null);
  const [loading, setLoading] = useState<boolean>(true);
  const [selectedBooking, setSelectedBooking] = useState<BookingDetail | null>(
    null
  );
  const [isEditModalOpen, setIsEditModalOpen] = useState(false);
  const [openDropdown, setOpenDropdown] = useState<string | null>(null);
  const [statuses, setStatuses] = useState<string[]>([]);

  const [totalPages, setTotalPages] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [dataToPaginate, setDataToPaginate] = useState<any[]>([]);

  const [isMasterChecked, setIsMasterChecked] = useState<boolean>(false);
  const [filteredBookingList, setFilteredBookingList] = useState<
    BookingDetail[]
  >([]);
  const [searchValue, setSearchValue] = useState<string | null>("");
  const [totalCount, setTotalCount] = useState<string | 0>("");
  const [showModal, setShowModal] = useState<boolean>(false);
  const [editingBooking, setEditingBooking] = useState<BookingDetail | null>(
    null
  );
  const [showSuccessMessage, setShowSuccessMessage] = useState<boolean>(false);
  const itemsPerPage = 9;
  const [createdDateFrom, setCreatedDateFrom] = useState<Date | undefined>(
    undefined
  );
  const [createdDateTo, setCreatedDateTo] = useState<Date | undefined>(
    undefined
  );
  const [isFilterVisible, setIsFilterVisible] = useState(false);
  const [showPersonModal, setShowPersonModal] = useState<boolean>(false);
  const [bookingPerson, setBookingPerson] = useState<BookingDetail | null>(
    null
  );
  const [splitedData, setSplitedData] = useState<BookingDetail | null>(null);
  const [selectedType, setSelectedType] = useState<string[]>([]);
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const history = useHistory();
  const [tempCreatedDateFrom, setTempCreatedDateFrom] = useState<
    Date | undefined
  >(undefined);
  const [tempCreatedDateTo, setTempCreatedDateTo] = useState<Date | undefined>(
    undefined
  );
  const [tempSelectedType, setTempSelectedType] = useState<string[]>([]);

  const dropdownRef = useRef<HTMLDivElement>(null);

  const [showDeleteConfirmationMessage, setShowDeleteConfirmationMessage] =
    useState(false);
  const [bookingToDeleteId, setBookingToDeleteId] = useState<string | null>(
    null
  );
  const [isConfirmDeleting, setConfirmDeleting] = useState<boolean>(false);
  const [showSplitsPopup, setShowSplitsPopup] = useState(false);
  const [selectedSplits, setSelectedSplits] = useState<SplitDetail[] | null>(
    null
  );

  const [statusDropdownOpen, setStatusDropdownOpen] = useState(false);
  const [tempSelectedStatuses, setTempSelectedStatuses] = useState<string[]>(
    []
  );
  const [selectedStatuses, setSelectedStatuses] = useState<string[]>([]);
  const statusDropdownRef = useRef<HTMLDivElement>(null);
  const [progress, setProgress] = React.useState<number>(0);
  const [showProgressBar, setShowProgressBar] = React.useState<boolean>(false);

  const options = [
    { value: "sea", label: "Sea" },
    { value: "land", label: "Land" },
    { value: "air", label: "Air" },
  ];

  const statusOptions = [
    { value: "shipment started", label: "In Transit" },
    { value: "collected for shipment", label: "Collected for Shipment" },
    { value: "deliverd to hub", label: "Delivered to Hub" },
    { value: "shipment progress", label: "Shipment Progress" },
    { value: "shipment ended", label: "Shipment Ended" },
    { value: "pending", label: "Pending" },
    { value: "delivered", label: "Delivered" },
    { value: "main booking", label: "Main Booking" },
    { value: "delivered shipment", label: "Delivered Shipment" },
    { value: "collected to shipment", label: "Collected to Shipment" },
    { value: "returned", label: "Returned" },
  ];

  const handleShipmentStatusChange = (value: string) => {
    setTempSelectedStatuses((prev) =>
      prev.includes(value)
        ? prev.filter((item) => item !== value)
        : [...prev, value]
    );

    setStatusDropdownOpen(false);
  };

  const handleRemoveShipmentStatus = (value: string) => {
    setTempSelectedStatuses((prev) => prev.filter((item) => item !== value));
  };

  const toggleStatusDropdown = (e: React.MouseEvent) => {
    e.stopPropagation();
    setStatusDropdownOpen((prev) => !prev);
  };

  const closeStatusDropdown = (event: MouseEvent) => {
    if (
      statusDropdownRef.current &&
      !statusDropdownRef.current.contains(event.target as Node)
    ) {
      setStatusDropdownOpen(false);
    }
  };

  useEffect(() => {
    document.addEventListener("click", closeStatusDropdown);
    return () => {
      document.removeEventListener("click", closeStatusDropdown);
    };
  }, []);

  // Handle Shipment Mode selection
  const handleStatusChange = (value: string) => {
    setTempSelectedType((prev) =>
      prev.includes(value)
        ? prev.filter((item) => item !== value)
        : [...prev, value]
    );
  };

  // Remove selected status
  const handleRemoveStatus = (value: string) => {
    setTempSelectedType((prev) => prev.filter((item) => item !== value));
  };

  // Toggle dropdown visibility
  const toggleDropdowns = (e: React.MouseEvent) => {
    e.stopPropagation(); // Prevent event propagation
    setDropdownOpen((prev) => !prev);
  };

  // Close dropdown when clicking outside
  const closeDropdown = (event: MouseEvent) => {
    if (
      dropdownRef.current &&
      !dropdownRef.current.contains(event.target as Node)
    ) {
      setDropdownOpen(false);
    }
  };

  useEffect(() => {
    document.addEventListener("click", closeDropdown);
    return () => {
      document.removeEventListener("click", closeDropdown);
    };
  }, []);

  const handleClearStatus = () => {
    setSelectedType([]);
    setSelectedStatuses([]);
    setCreatedDateFrom(undefined);
    setCreatedDateTo(undefined);

    setTempSelectedType([]);
    setTempSelectedStatuses([]);
    setTempCreatedDateFrom(undefined);
    setTempCreatedDateTo(undefined);
  };

  const handleApplyFilters = () => {
    setSelectedType(tempSelectedType);
    setSelectedStatuses(tempSelectedStatuses);
    setCreatedDateFrom(tempCreatedDateFrom);
    setCreatedDateTo(tempCreatedDateTo);

    const createdDateFromUTC = tempCreatedDateFrom
      ? new Date(
        tempCreatedDateFrom.getTime() -
        tempCreatedDateFrom.getTimezoneOffset() * 60000
      )
      : undefined;
    const createdDateToUTC = tempCreatedDateTo
      ? new Date(
        tempCreatedDateTo.getTime() -
        tempCreatedDateTo.getTimezoneOffset() * 60000
      )
      : undefined;

    fetchBookings({
      statuses: tempSelectedType,
      shipmentStatuses: tempSelectedStatuses,
      createdDateFrom: createdDateFromUTC,
      createdDateTo: createdDateToUTC,
    });

    setIsFilterVisible(false);
  };

  const fetchBookings = async ({
    statuses = [],
    shipmentStatuses = [],
    createdDateFrom,
    createdDateTo,
  }: {
    statuses?: string[];
    shipmentStatuses?: string[];
    createdDateFrom?: Date;
    createdDateTo?: Date;
  }) => {
    setLoading(true);
    try {
      const formatDate = (date: Date | undefined) =>
        date
          ? `${String(date.getDate()).padStart(2, "0")}/${String(
            date.getMonth() + 1
          ).padStart(2, "0")}/${date.getFullYear()}`
          : "";

      const formattedFromDate = formatDate(createdDateFrom);
      const formattedToDate = formatDate(createdDateTo);

      console.log("Formatted From Date:", formattedFromDate);
      console.log("Formatted To Date:", formattedToDate);

      const normalizedSearchValue = (searchValue || "")
        .trim()
        .replace(/\s+/g, " ");

      // 🧠 Build query params dynamically
      const queryParams = [
        `page=${currentPage}`,
        `limit=${itemsPerPage}`,
        `search=${encodeURIComponent(normalizedSearchValue)}`,
        statuses.length > 0 ? `shipment_mode=${statuses.join(",")}` : "",
        shipmentStatuses.length > 0
          ? `status=${shipmentStatuses.join(",")}`
          : "", // 👈 correct param name
        formattedFromDate ? `fromDate=${formattedFromDate}` : "",
        formattedToDate ? `toDate=${formattedToDate}` : "",
      ]
        .filter(Boolean)
        .join("&");

      const response = await fetch(
        `https://backendcway.causewaycargo.com/superadmin/getallbooking?${queryParams}`,
        {
          method: "GET",
          headers: {
            auth: "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpZCI6Nywicm9sZSI6InN1cGVyX2FkbWluIiwiaWF0IjoxNzI2ODM0MzIwfQ.edXyvu0znbVoi5KU3iL8FPww3qe8LMU0oXOCwdZi8do",
          },
        }
      );

      if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`);
      }

      const result = await response.json();
      setTotalCount(result?.totalCount);

      if (result.status === "success") {
        let filteredData = result?.data as BookingDetail[];

        console.log("Original Data:", filteredData);

        // Optional frontend fallback filtering (can be removed if backend handles both)
        if (statuses.length > 0) {
          filteredData = filteredData.filter((booking) =>
            statuses.includes(booking.shipment_mode)
          );
          console.log("Data after status filter:", filteredData);
        }

        // if (shipmentStatuses.length > 0) {
        //   filteredData = filteredData.filter((booking) =>
        //     shipmentStatuses.includes(booking.shipment_status)
        //   );
        // }

        setDataToPaginate(filteredData);
        setFilteredBookingList(filteredData);
        setTotalPages(parseInt(result.pagination.totalPages));
        setError(null);
      } else {
        throw new Error("Failed to fetch data");
      }
    } catch (err) {
      setError(
        `Error: ${err instanceof Error ? err.message : "An unknown error occurred"
        }`
      );
    } finally {
      setLoading(false);
    }
  };

  const startIndex = (currentPage - 1) * itemsPerPage;

  const currentBookings = dataToPaginate.slice(
    startIndex,
    startIndex + itemsPerPage
  );

  const handlePageChange = (page: number) => {
    if (page > 0 && page <= totalPages) {
      setCurrentPage(page);
    }
  };

  useEffect(() => {
    fetchBookings({
      statuses: selectedType,
      shipmentStatuses: selectedStatuses,
      createdDateFrom,
      createdDateTo,
    });
  }, [
    searchValue,
    createdDateFrom,
    createdDateTo,
    currentPage,
    selectedType,
    selectedStatuses,
  ]);
  let progressInterval: NodeJS.Timeout | null = null;
  const handleExportToExcel = async () => {
    setProgress(0);
    setShowProgressBar(true);
    let progressInterval = setInterval(() => {
      setProgress((prevProgress) => {
        return prevProgress < 90 ? prevProgress + 0.5 : prevProgress;
      });
    }, 300);

    let dataToExport: any[] = [];

    function formatDateDMY(date: Date): string {
      const d = String(date.getDate()).padStart(2, "0");
      const m = String(date.getMonth() + 1).padStart(2, "0");
      const y = date.getFullYear();
      return `${d}/${m}/${y}`;
    }

    if (isMasterChecked) {
      const createdDateFrom = tempCreatedDateFrom
        ? new Date(
          tempCreatedDateFrom.getTime() -
          tempCreatedDateFrom.getTimezoneOffset() * 60000
        )
        : undefined;
      const createdDateTo = tempCreatedDateTo
        ? new Date(
          tempCreatedDateTo.getTime() -
          tempCreatedDateTo.getTimezoneOffset() * 60000
        )
        : undefined;

      const queryParams = new URLSearchParams();

      if (createdDateFrom) {
        queryParams.append("fromDate", formatDateDMY(createdDateFrom));
      }
      if (createdDateTo) {
        queryParams.append("toDate", formatDateDMY(createdDateTo));
      }

      if (tempSelectedType.length > 0)
        queryParams.append("shipment_mode", tempSelectedType.join(","));
      if (tempSelectedStatuses.length > 0)
        queryParams.append("status", tempSelectedStatuses.join(","));
      queryParams.append("exportAll", "true");

      try {
        const response = await fetch(
          `https://backendcway.causewaycargo.com/superadmin/getallbooking?${queryParams.toString()}`
        );

        if (!response.ok) {
          throw new Error("Failed to fetch booking data");
        }

        const body = await response.json();
        dataToExport = body.data;
        setProgress(95);
      } catch (error) {
        alert("Error fetching data for export");
        clearInterval(progressInterval);
        setProgress(0);
        setShowProgressBar(false);
        return;
      }
    } else {
      dataToExport = selectedBookings;
      setProgress(95);
    }

    if (dataToExport.length === 0) {
      alert("No data selected to export!");
      clearInterval(progressInterval);
      setProgress(0);
      setShowProgressBar(false);
      return;
    }
    const headers: string[] = [
      "Booking ID",
      "Shipment ID",
      "Booking Type",
      "Consignor",
      "Consignee",
      "Box Quantity",
      "Shipment Mode",
      "Created Date",
      "Payment Mode",
      "Status",
    ];

    const formattedData = dataToExport.map((booking) => ({
      "Booking ID": booking.booking_id,
      "Shipment ID": booking.shipment_id || "N/A",
      "Booking Type": booking.booking_mode,
      Consignor: booking.consignor,
      Consignee: booking.consignee,
      "Box Quantity": booking.total_quantity,
      "Shipment Mode": booking.shipment_mode || "N/A",
      "Created Date": booking.created_at
        ? new Date(booking.created_at).toLocaleDateString("en-GB")
        : "N/A",
      "Payment Mode": booking.payment_mode || "N/A",
      Status:
        booking.shipment_status === "Shipment Started"
          ? "In Transit"
          : booking.shipment_status,
    }));
    const wb = XLSX.utils.book_new();
    const ws = XLSX.utils.json_to_sheet(formattedData, { header: headers });
    const colWidths = headers.map((header) => ({
      wch: Math.max(
        header.length,
        ...formattedData.map((row) =>
          (row as Record<string, any>)[header]
            ? (row as Record<string, any>)[header].toString().length
            : 0
        )
      ),
    }));

    ws["!cols"] = colWidths;
    XLSX.utils.book_append_sheet(wb, ws, "Bookings");
    clearInterval(progressInterval);
    setProgress(100);
    XLSX.writeFile(wb, "Bookings.xlsx");
    setTimeout(() => {
      setShowProgressBar(false);
    }, 500);
  };

  const handleCheckboxChange = (booking: BookingDetail, isChecked: boolean) => {
    if (isChecked) {
      setSelectedBookings((prev) => [...prev, booking]);
    } else {
      setSelectedBookings((prev) => prev.filter((b) => b.id !== booking.id));
    }
  };

  const handleMasterCheckboxChange = (
    e: React.ChangeEvent<HTMLInputElement>
  ) => {
    const isChecked = e.target.checked;
    setIsMasterChecked(isChecked);

    if (isChecked) {
      setSelectedBookings(dataToPaginate);
    } else {
      setSelectedBookings([]);
    }
  };

  const getBadgeClass = (status: string) => {
    switch (status?.toLowerCase()) {
      case "shipment started":
        return "badge badge-light-info";
      case "collected for shipment":
        return "badge badge-light-success";
      case "deliverd to hub":
        return "badge badge-light-warning";
      case "shipment progress":
        return "badge badge-light-primary";
      case "shipment ended":
        return "badge badge-light-danger";
      case "pending":
        return "badge badge-light-warning";
      case "delivered":
        return "badge badge-light-success";
      case "main booking":
        return "badge badge-light-primary";
      case "delivered shipment":
        return "badge badge-light-success";
      case "collected to shipment":
        return "badge badge-light-success";
      case "returned":
        return "badge btn-successt";
      default:
        return "badge badge-light-secondary";
    }
  };

  const getShipmentModeIcon = (mode: string) => {
    switch (mode) {
      case "air":
        return air;
      case "sea":
        return ship;
      case "land":
        return Truck;
      case "Road":
        return Truck;
      default:
        return null;
    }
  };

  //--------------------Booking Person--------------------

  const handlePrintBooking = (booking_id: string) => {
    history.push({
      pathname: "/bookingprint",
      state: { booking_id: booking_id },
    });
  };
  const handleViewBooking = async (booking_id: string, where: string) => {
    try {
      const response = await fetch(
        "https://backendcway.causewaycargo.com/superadmin/viewparticularbooking",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            auth: "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpZCI6Nywicm9sZSI6InN1cGVyX2FkbWluIiwiaWF0IjoxNzI2ODM0MzIwfQ.edXyvu0znbVoi5KU3iL8FPww3qe8LMU0oXOCwdZi8do",
          },
          body: JSON.stringify({ booking_id }),
        }
      );

      if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`);
      }

      const result = await response.json();
      console.log("View Booking API Response:", result);

      if (result.status === "success") {
        if (where === "view") {
          setBookingPerson(result.data[0]);
          console.log("Each booking", result.data);

          console.log("Splited Data", result.data.splits);
          setShowPersonModal(true);
          setError(null);
        } else {
          history.push({
            pathname: "/bookingprint",
            state: { booking_id: result.data[0].booking_id },
          });
        }
        console.log("Full person data", result.data);
      } else {
        throw new Error("Failed to fetch booking data");
      }
    } catch (err) {
      if (err instanceof Error) {
        setError(`Error: ${err.message}`);
      } else {
        setError("An unknown error occurred");
      }
    }
  };

  const toggleDropdown = (bookingId: string) => {
    if (openDropdown === bookingId) {
      setOpenDropdown(null);
    } else {
      setOpenDropdown(bookingId);
    }
  };

  const handleClickOutside = (event: MouseEvent) => {
    if (
      dropdownRef.current &&
      !dropdownRef.current.contains(event.target as Node)
    ) {
      setOpenDropdown(null);
    }
  };

  useEffect(() => {
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const handleClearSearch = () => {
    setSearchValue("");
  };

  // --------------Splits data view-------------------------//

  const handleShowSplits = (booking: BookingDetail) => {
    console.log("Splited Booking", bookingDetails);
    if (booking.splits && booking.splits.length > 0) {
      setSelectedSplits(booking.splits);
      console.log("show split booking", booking.splits);
      setShowSplitsPopup(true);
    }
  };

  const handleCloseSplitsPopup = () => {
    setShowSplitsPopup(false);
    setSelectedSplits(null);
  };

  const getSplitBadgeClass = (status: string) => {
    switch (status?.toLowerCase()) {
      case "shipped":
        return "badge badge-light-success border border-success";
      case "collected to shipment":
        return "badge-light-success badge border border-success";
      case "pending":
        return "badge badge-light-warning border border-warning";
      case "Delivered":
        return "badge-light-success badge border border-success";
      case "shipment started":
        return "badge badge-light-info border border-info";
      case "shipment ended":
        return "badge badge-light-primary border border-primary";
      default:
        return "badge-light-success badge border border-success";
    }
  };

  //----------------------------Booking Delete------------------------

  const handleDeleteBooking = (bookingId: string) => {
    setBookingToDeleteId(bookingId);
    setShowDeleteConfirmationMessage(true);
  };

  const confirmDeleteBooking = async () => {
    setConfirmDeleting(true);
    if (bookingToDeleteId !== null) {
      try {
        const response = await fetch(
          "https://backendcway.causewaycargo.com/superadmin/deleteparticularbooking",
          {
            method: "DELETE",
            headers: {
              "Content-Type": "application/json",
              auth: "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpZCI6Nywicm9sZSI6InN1cGVyX2FkbWluIiwiaWF0IjoxNzI2ODM0MzIwfQ.edXyvu0znbVoi5KU3iL8FPww3qe8LMU0oXOCwdZi8do",
            },
            body: JSON.stringify({ booking_id: bookingToDeleteId }),
          }
        );

        if (!response.ok) {
          throw new Error(`HTTP error! Status: ${response.status}`);
        }

        const result = await response.json();
        console.log("Delete API Response:", result);

        if (result.status === "success") {
          setBookingDetails((prevBookings) =>
            prevBookings.filter(
              (booking) => booking.booking_id !== bookingToDeleteId
            )
          );
          setFilteredBookingList((prevBookings) =>
            prevBookings.filter(
              (booking) => booking.booking_id !== bookingToDeleteId
            )
          );
          console.log("Booking deleted successfully");
          setConfirmDeleting(false);
          fetchBookings({
            statuses: [],
            createdDateFrom: undefined,
            createdDateTo: undefined,
          });
        } else {
          console.error("Failed to delete booking:", result.message);
          setConfirmDeleting(false);
        }
      } catch (error) {
        console.error("Error deleting booking:", error);
        alert(
          "An error occurred while deleting the booking. Please try again."
        );
      } finally {
        setShowDeleteConfirmationMessage(false);
        setBookingToDeleteId(null);
        setConfirmDeleting(false);
      }
    }
  };

  //----------------------------Booking Return----------------------------

  const [showReturnConfirmationMessage, setShowReturnConfirmationMessage] =
    useState(false);
  const [bookingToReturnId, setBookingToReturnId] = useState<string | null>(
    null
  );
  const [isConfirmReturn, setConfirmReturn] = useState<boolean>(false);

  const handleReturnBooking = (bookingId: string) => {
    setBookingToReturnId(bookingId);
    setShowReturnConfirmationMessage(true);
  };

  const confirmReturnBooking = async () => {
    setConfirmReturn(true);
    if (bookingToReturnId !== null) {
      try {
        const response = await fetch(
          "https://backendcway.causewaycargo.com/superadmin/bookingreturn",
          {
            method: "PUT",
            headers: {
              "Content-Type": "application/json",
              auth: "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpZCI6Nywicm9sZSI6InN1cGVyX2FkbWluIiwiaWF0IjoxNzI2ODM0MzIwfQ.edXyvu0znbVoi5KU3iL8FPww3qe8LMU0oXOCwdZi8do",
            },
            body: JSON.stringify({ booking_id: bookingToReturnId }),
          }
        );

        if (!response.ok) {
          throw new Error(`HTTP error! Status: ${response.status}`);
        }

        const result = await response.json();
        console.log("Delete API Response:", result);

        if (result.status === "success") {
          setBookingDetails((prevBookings) =>
            prevBookings.filter(
              (booking) => booking.booking_id !== bookingToReturnId
            )
          );
          setFilteredBookingList((prevBookings) =>
            prevBookings.filter(
              (booking) => booking.booking_id !== bookingToReturnId
            )
          );
          console.log("Booking Return successfully");
          setConfirmReturn(false);
          fetchBookings({
            statuses: [],
            createdDateFrom: undefined,
            createdDateTo: undefined,
          });
        } else {
          console.error("Failed to delete booking:", result.message);
          setConfirmReturn(false);
        }
      } catch (error) {
        console.error("Error deleting booking:", error);
        alert(
          "An error occurred while deleting the booking. Please try again."
        );
      } finally {
        setShowReturnConfirmationMessage(false);
        setBookingToReturnId(null);
        setConfirmReturn(false);
      }
    }
  };

  useEffect(() => {
    if (progress === 100) {
      setTimeout(() => {
        setShowProgressBar(false);
        setProgress(0);
      }, 500);
    }
  }, [progress]);

  return (
    <div className={`card`}>
      {showProgressBar && (
        <>
          <div className="modal-backdrop shadow-lg rounded-5">
            <div className="modal d-block" tabIndex={-1} role="dialog">
              <div
                className="modal-dialog modal-dialog-centered"
                role="document"
              >
                <div className="modal-content pb-10 pt-4">
                  <div className="modal-header py-2 d-flex justify-content-end">
                    <div className="modal-body">
                      <h5 className="mb-4">Exporting Data...</h5>
                      <div className="progress" style={{ height: "20px" }}>
                        <div
                          className="progress-bar progress-bar-striped progress-bar-animated bg-primary"
                          role="progressbar"
                          style={{ width: `${progress}%` }}
                          aria-valuenow={progress}
                          aria-valuemin={0}
                          aria-valuemax={100}
                        >
                          {Math.round(progress)}%
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </>
      )}

      <ToastContainer />
      <div className="card-header border-0 px-4 pt-4">
        <div className="d-flex ml-4 align-items-center ">
          <h3 className="card-title align-items-start flex-column">
            <span className="card-label fw-bolder fs-3 mb-1">
              Booking Lists
            </span>
            <span className="text-muted mt-1 fw-bold fs-7">
              Total {totalCount.toLocaleString()} Bookings
            </span>
          </h3>
          <div className="input-group d-flex align-items-center border-dark border py-2 rounded-3 w-xl-200px w-md-150px">
            <span className=" bg-white px-2 border-0 h-25" id="search-icon">
              <i className="bi bi-search"></i>
            </span>
            <input
              type="search"
              className="form-control py-0 border-0 shadow-none"
              placeholder="Search..."
              aria-label="Search"
              aria-describedby="search-icon"
              value={searchValue ?? ""}
              onChange={(e) => setSearchValue(e.target.value)}
            />
          </div>
        </div>
        <div className="menu-item">
          <div className="menu-content px-0 py-3 d-flex">
            <div>
              <button
                type="button"
                className="btn btn-sm btn-primary btn-active-primary me-2"
                data-kt-menu-trigger="click"
                data-kt-menu-placement="bottom-end"
                data-kt-menu-flip="top-end"
              >
                <KTSVG
                  path="/media/icons/duotune/general/gen031.svg"
                  className="svg-icon-3 svg-icon-primary"
                />
                Filters
              </button>

              <div
                className="menu menu-sub menu-sub-dropdown w-250px w-md-300px"
                ref={dropdownRef}
                data-kt-menu="true"
              >
                <div className="px-7 py-5">
                  <div className="fs-5 text-dark fw-bolder">Filter Options</div>
                </div>

                <div className="separator border-gray-200"></div>
                <div className="px-7 py-5">
                  {/* Shipment Mode Filter */}
                  <div className="mb-6" onClick={(e) => e.stopPropagation()}>
                    <label className="form-label fw-bold">Shipment Mode:</label>
                    <div
                      className="custom-select-container position-relative"
                      onClick={toggleDropdowns}
                    >
                      <div
                        className="border rounded py-3 px-2"
                        style={{
                          cursor: "pointer",
                          backgroundColor: "#F9F9F9",
                        }}
                      >
                        {tempSelectedType.length > 0 ? (
                          tempSelectedType.map((status) => (
                            <span
                              key={status}
                              className="badge bg-primary me-1"
                            >
                              {
                                options.find(
                                  (option) => option.value === status
                                )?.label
                              }
                              <FaTimes
                                onClick={(e) => {
                                  e.stopPropagation();
                                  handleRemoveStatus(status);
                                }}
                                className="ms-1"
                                style={{ cursor: "pointer" }}
                              />
                            </span>
                          ))
                        ) : (
                          <span className="text-muted">Select option</span>
                        )}
                      </div>
                      {dropdownOpen && (
                        <ul
                          className="list-group position-absolute mt-1 w-100"
                          style={{ zIndex: 1 }}
                        >
                          {options.map((option) => (
                            <li
                              key={option.value}
                              className={`list-group-item d-flex justify-content-between align-items-center border-0 ${selectedType.includes(option.value)
                                ? "bg-light text-primary"
                                : ""
                                }`}
                              onClick={(e) => {
                                e.stopPropagation();
                                handleStatusChange(option.value);
                              }}
                            >
                              {option.label}
                              {selectedType.includes(option.value) && (
                                <FaCheck />
                              )}
                            </li>
                          ))}
                        </ul>
                      )}
                    </div>
                  </div>

                  {/* Shipment Status Filter */}
                  <div className="mb-6" onClick={(e) => e.stopPropagation()}>
                    <label className="form-label fw-bold">
                      Shipment Status:
                    </label>
                    <div
                      className="custom-select-container position-relative"
                      onClick={toggleStatusDropdown}
                      ref={statusDropdownRef}
                    >
                      <div
                        className="border rounded py-3 px-2"
                        style={{
                          cursor: "pointer",
                          backgroundColor: "#F9F9F9",
                        }}
                      >
                        {tempSelectedStatuses.length > 0 ? (
                          tempSelectedStatuses.map((status) => (
                            <span
                              key={status}
                              className="badge bg-primary me-1"
                            >
                              {
                                statusOptions.find(
                                  (option) => option.value === status
                                )?.label
                              }
                              <FaTimes
                                onClick={(e) => {
                                  e.stopPropagation();
                                  handleRemoveShipmentStatus(status);
                                }}
                                className="ms-1"
                                style={{ cursor: "pointer" }}
                              />
                            </span>
                          ))
                        ) : (
                          <span className="text-muted">Select status</span>
                        )}
                      </div>
                      {statusDropdownOpen && (
                        <ul
                          className="list-group position-absolute mt-1 w-100"
                          style={{
                            zIndex: 1,
                            overflow: "auto",
                            height: "10vh",
                          }}
                        >
                          {statusOptions.map((option) => (
                            <li
                              key={option.value}
                              className={`list-group-item d-flex justify-content-between align-items-center border-0 ${tempSelectedStatuses.includes(option.value)
                                ? "bg-light text-primary"
                                : ""
                                }`}
                              onClick={(e) => {
                                e.stopPropagation();
                                handleShipmentStatusChange(option.value);
                              }}
                            >
                              {option.label}
                              {tempSelectedStatuses.includes(option.value) && (
                                <FaCheck />
                              )}
                            </li>
                          ))}
                        </ul>
                      )}
                    </div>
                  </div>

                  {/* Date Filter */}
                  <div className="d-flex mb-3 align-items-center">
                    <div onClick={(e) => e.stopPropagation()}>
                      <DatePicker
                        selected={tempCreatedDateFrom}
                        onChange={(date) =>
                          setTempCreatedDateFrom(date || undefined)
                        }
                        selectsStart
                        startDate={tempCreatedDateFrom}
                        endDate={tempCreatedDateTo}
                        maxDate={new Date()}
                        className="form-control"
                        placeholderText="From"
                        dateFormat="dd/MM/yyyy"
                      />
                    </div>

                    <span className="mx-2">to</span>
                    <div onClick={(e) => e.stopPropagation()}>
                      <DatePicker
                        selected={tempCreatedDateTo}
                        onChange={(date) =>
                          setTempCreatedDateTo(date || undefined)
                        }
                        selectsEnd
                        startDate={tempCreatedDateFrom}
                        endDate={tempCreatedDateTo}
                        minDate={tempCreatedDateFrom}
                        maxDate={new Date()}
                        className="form-control"
                        placeholderText="To"
                        dateFormat="dd/MM/yyyy"
                      />
                    </div>
                  </div>

                  <div className="d-flex justify-content-end">
                    <button
                      type="reset"
                      className="btn btn-sm btn-white btn-active-light-primary me-2"
                      data-kt-menu-dismiss="true"
                      onClick={handleClearStatus}
                    >
                      Reset
                    </button>

                    <button
                      type="submit"
                      className="btn btn-sm btn-primary"
                      data-kt-menu-dismiss="true"
                      onClick={handleApplyFilters}
                    >
                      Apply
                    </button>
                  </div>
                </div>
              </div>
            </div>
            <span className="btn btn-primary btn-sm px-4 me-2 text-white">
              <Link
                to="/bookingtable/bookingform"
                className="text-white d-flex align-items-center"
              >
                <img
                  src={toAbsoluteUrl("/media/icons/duotune/arrows/+icon.svg")}
                  alt=""
                  width={10}
                  className="svg-icon-3 me-2"
                />
                Add Booking
              </Link>
            </span>

            <button
              className="btn btn-danger btn-sm px-4"
              onClick={handleExportToExcel}
              disabled={selectedBookings?.length === 0}
            >
              Export to Excel
            </button>
          </div>
        </div>
      </div>

      <div className="card-body mt-2">
        {loading ? (
          <div
            className="d-flex justify-content-center align-items-center"
            style={{ minHeight: "400px" }}
          >
            <img src={loadingimage} alt="Loading..." className="w-20" />
          </div>
        ) : (
          <div className="table-responsive">
            <table className="table table-row-bordered table-row-gray-100 align-middle gs-0 gy-3">
              <thead>
                <tr className="fw-bolder text-muted">
                  <th className="w-25px">
                    <div className="form-check form-check-sm form-check-custom form-check-solid">
                      <input
                        aria-label="input"
                        className="form-check-input"
                        type="checkbox"
                        checked={isMasterChecked}
                        onChange={handleMasterCheckboxChange}
                      />
                    </div>
                  </th>
                  <th className="min-w-160px">Booking ID</th>
                  <th className="min-w-160px">Shipment ID</th>
                  <th className="min-w-160px">Booking Type</th>
                  <th className="min-w-140px">Consignor</th>
                  <th className="min-w-140px">Consignee</th>
                  <th className="min-w-120px">Box Quantity</th>
                  <th className="min-w-100px">Shipment Mode</th>
                  <th className="min-w-100px">Created Date</th>
                  <th className="min-w-100px">Payment Mode</th>
                  <th className="min-w-120px">Status</th>
                  <th className="min-w-120px">Splits</th>
                  <th className="min-w-50px text-end">Actions</th>
                </tr>
              </thead>
              <tbody>
                {dataToPaginate?.map((booking, index) => (
                  <tr key={index}>
                    <td>
                      <div className="form-check form-check-sm form-check-custom form-check-solid">
                        <input
                          aria-label="input"

                          className="form-check-input widget-13-check"
                          type="checkbox"
                          checked={selectedBookings.includes(booking)}
                          onChange={(e) =>
                            handleCheckboxChange(booking, e.target.checked)
                          }
                        />
                      </div>
                    </td>
                    <td className="text-dark fw-bolder text-hover-primary">
                      {booking.booking_id}
                    </td>
                    <td className="text-dark fw-bolder text-hover-primary">
                      {booking.shipment_id || "N/A"}
                    </td>
                    <td className="text-capitalize">{booking.booking_mode}</td>
                    <td title={booking.consignor} style={{ cursor: 'pointer', maxWidth: '150px', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
                      {booking.consignor}
                    </td>
                    <td title={booking.consignee} style={{ cursor: 'pointer', maxWidth: '150px', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
                      {booking.consignee}
                    </td>
                    <td>
                      <div className="d-flex align-items-center">
                        <i className="bi bi-box" style={{ color: "blue" }}></i>
                        <span className="ms-2">
                          {booking.booking_mode === 'normal booking'
                            ? booking.nrml_payment_quantity
                            : (booking.large_box_quantity || 0) +
                            (booking.medium_box_quantity || 0) +
                            (booking.small_box_quantity || 0)}
                        </span>
                      </div>
                    </td>
                    <td>
                      <div className="shipment-mode-container">
                        <img
                          src={getShipmentModeIcon(booking.shipment_mode) || ""}
                          alt={booking.shipment_mode}
                          className="shipment-icon"
                        />
                        <span className="shipment-mode-text">
                          {booking.shipment_mode}
                        </span>
                      </div>
                    </td>
                    <td>
                      {" "}
                      {moment(booking?.created_at).format("DD-MM-YYYY")}{" "}
                    </td>

                    <td>
                      {booking.who_paid ? (
                        <div className="">
                          <span className="">{booking.who_paid}</span>
                        </div>
                      ) : (
                        <span className="text-muted">N/A</span>
                      )}
                    </td>

                    <td>
                      <span className={getBadgeClass(booking?.shipment_status)}>
                        {booking.shipment_status === "Shipment Started"
                          ? "In Transit"
                          : booking.shipment_status}
                      </span>
                    </td>
                    <td>
                      {booking.splits && booking.splits.length > 0 ? (
                        <div
                          onClick={() => handleShowSplits(booking)}
                          style={{ cursor: "pointer" }}
                        >
                          <KTSVG
                            path="/media/icons/duotune/arrows/Split icon.svg"
                            className="svg-icon-2 customs-icon-split"
                          />
                        </div>
                      ) : (
                        <span style={{ cursor: "no-drop" }}>
                          {" "}
                          <KTSVG
                            path="/media/icons/duotune/arrows/arr030.svg"
                            className="svg-icon-2"
                          />
                        </span>
                      )}
                    </td>
                    <td className="d-flex justify-content-end">
                      <div key={booking.booking_id} className="card-toolbar">
                        <button
                          type="button"
                          className="btn btn-sm btn-icon btn-color-primary btn-active-light-primary"
                          style={{ position: "relative" }}
                          onClick={() => toggleDropdown(booking.booking_id)}
                        >
                          <KTSVG
                            path="/media/icons/duotune/general/gen024.svg"
                            className="svg-icon-2"
                          />
                        </button>
                        {openDropdown === booking.booking_id && (
                          <div
                            ref={dropdownRef}
                            className="dropdown-menu show"
                            style={{
                              position: "absolute",
                              right: 70,
                              zIndex: 1,
                              display: "block",
                              backgroundColor: "white",
                              boxShadow:
                                "0 0.125rem 0.25rem rgba(0, 0, 0, 0.075)",
                              border: "1px solid rgba(0, 0, 0, 0.15)",
                              borderRadius: "0.25rem",
                              padding: "0.5rem 0",
                            }}
                          >
                            <a
                              href="#"
                              className="dropdown-item"
                              onClick={(e) => {
                                e.preventDefault();
                                handleViewBooking(booking.booking_id, "view");
                                setOpenDropdown(null);
                              }}
                            >
                              View
                            </a>
                            {booking.shipment_status === "pending" && (
                              <a
                                href="#"
                                className="dropdown-item"
                                onClick={(e) => {
                                  e.preventDefault();
                                  setSelectedBooking(booking); // Store selected booking
                                  setIsEditModalOpen(true); // Open the modal
                                }}
                              >
                                Edit
                              </a>
                            )}

                            {booking.shipment_status === "pending" && (
                              <a
                                href="#"
                                className="dropdown-item"
                                onClick={() =>
                                  handleDeleteBooking(booking.booking_id)
                                }
                              >
                                Delete
                              </a>
                            )}
                            {booking.shipment_status === "pending" && (
                              <a
                                href="#"
                                className="dropdown-item"
                                onClick={() =>
                                  handleReturnBooking(booking.booking_id)
                                }
                              >
                                Return
                              </a>
                            )}

                            <a
                              href="#"
                              className="dropdown-item"
                              onClick={(e) => {
                                e.preventDefault();
                                handlePrintBooking(booking.booking_id);
                                setOpenDropdown(null);
                              }}
                            >
                              Print
                            </a>
                          </div>
                        )}
                      </div>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
            {dataToPaginate.length > 0 ? (
              <div className="d-flex justify-content-center mb-3">
                <button
                  className="btn btn-light-primary me-1 px-4 py-2"
                  disabled={currentPage === 1}
                  onClick={() => handlePageChange(currentPage - 1)}
                >
                  <KTSVG
                    path="/media/icons/duotune/arrows/arr079.svg"
                    className="svg-icon-3"
                  />
                </button>
                <div>
                  {Array.from({ length: totalPages }, (_, i) => {
                    const pageNumber = i + 1;
                    if (
                      pageNumber === 1 ||
                      pageNumber === totalPages ||
                      (pageNumber >= currentPage - 1 &&
                        pageNumber <= currentPage + 1)
                    ) {
                      return (
                        <button
                          key={pageNumber}
                          className={`btn btn-light-primary mx-1 px-4 py-2 ${currentPage === pageNumber ? "active" : ""
                            }`}
                          onClick={() => handlePageChange(pageNumber)}
                        >
                          {pageNumber}
                        </button>
                      );
                    }
                    if (
                      pageNumber === currentPage - 2 ||
                      pageNumber === currentPage + 2
                    ) {
                      return (
                        <span key={pageNumber} className="mx-2 text-muted">
                          ...
                        </span>
                      );
                    }
                    return null;
                  })}
                </div>
                <button
                  className="btn btn-light-primary px-4 py-2 ms-1"
                  disabled={currentPage === totalPages}
                  onClick={() => handlePageChange(currentPage + 1)}
                >
                  <KTSVG
                    path="/media/icons/duotune/arrows/arr080.svg"
                    className="svg-icon-3"
                  />
                </button>
              </div>
            ) : (
              <div className="text-center py-4 text-gray-500">
                🚫 No Bookings Available
              </div>
            )}
          </div>
        )}
      </div>
      {showPersonModal && (
        <div className="modal-backdrop shadow-lg rounded-5">
          <div className="modal fade show d-block" tabIndex={-1} role="dialog">
            <div
              className="modal-dialog modal-dialog-centered modal-lg"
              role="document"
            >
              <div className="modal-content pb-3 pt-4">
                <div className="modal-header py-2 d-flex justify-content-end">
                  <button
                    type="button"
                    className="btn-close"
                    onClick={() => setShowPersonModal(false)}
                  ></button>
                </div>
                <div className="modal-body-dummy">
                  {bookingPerson && (
                    <div className="p-3">
                      <div className="row mb-3 px-6">
                        <div className="col-md-6">
                          <div
                            className="mb-3 d-flex flex-column"
                            style={{ rowGap: "9px" }}
                          >
                            <span className="text-sm pb-2">Booking ID:</span>
                            <h6>{bookingPerson.booking_id}</h6>
                          </div>
                          <div
                            className="mb-3 d-flex flex-column"
                            style={{ rowGap: "9px" }}
                          >
                            <span className="text-sm">Consignor:</span>
                            <h6>{bookingPerson.consignor}</h6>
                          </div>
                          <div
                            className="mb-3 d-flex flex-column"
                            style={{ rowGap: "9px" }}
                          >
                            <span className="text-sm">Consignor Address:</span>
                            <h6>{bookingPerson.consignor_address}</h6>
                          </div>
                        </div>

                        <div className="col-md-6">
                          <div
                            className="mb-3 d-flex flex-column"
                            style={{ rowGap: "9px" }}
                          >
                            <span className="text-sm">Consignee:</span>
                            <h6>{bookingPerson.consignee}</h6>
                          </div>
                          <div
                            className="mb-3 d-flex flex-column"
                            style={{ rowGap: "9px" }}
                          >
                            <span className="text-sm">Consignee Address:</span>
                            <h6>{bookingPerson.consignee_address}</h6>
                          </div>
                        </div>
                      </div>

                      <div className="bg-light-primary rounded p-3 px-6 py-3">
                        <div className="d-flex justify-content-between align-items-center mb-3">
                          <div>
                            <p className="text-muted">Invoice Details</p>
                            <h5 className="fw-bold">{bookingPerson.invoice_value}</h5>
                          </div>
                        </div>

                        <div className="row mb-3">
                          <div className="col-sm-4 mb-3">
                            <p className="text-sm">Shipment Mode</p>
                            <h6>{bookingPerson.shipment_mode}</h6>
                          </div>
                          <div className="col-sm-4 mb-3">
                            <p className="text-sm">Shipment Status</p>
                            <h6>
                              {bookingPerson.shipment_status ===
                                "Shipment Started"
                                ? "In Transit"
                                : bookingPerson.shipment_status}
                            </h6>
                          </div>
                          <div className="col-sm-4 mb-3">
                            <p className="text-sm">Payment Mode</p>
                            <h6>{bookingPerson.who_paid}</h6>
                          </div>
                        </div>
                        {bookingPerson?.booking_mode === "normal booking" ? (
                          <div className="row mb-3">
                            <div className="col-sm-4 mb-3">
                              <p className="text-sm">Normal Box Quantity</p>
                              <h6>{bookingPerson.nrml_payment_quantity}</h6>
                            </div>
                            {bookingPerson?.payment_mode ===
                              "normal booking" && (
                                <div className="col-sm-4 mb-3">
                                  <p className="text-sm">Normal Unitprice</p>
                                  <h6>{bookingPerson.nrml_quantity_price}</h6>
                                </div>
                              )}
                            {bookingPerson?.payment_mode ===
                              "CBM Rate Method" && (
                                <>
                                  <div className="col-sm-4 mb-3">
                                    <p className="text-sm">CBM Quantity</p>
                                    <h6>{bookingPerson.cbm_value}</h6>
                                  </div>
                                  <div className="col-sm-4 mb-3">
                                    <p className="text-sm">CBM Price</p>
                                    <h6>{bookingPerson.total_cbm_price}</h6>
                                  </div>
                                </>
                              )}
                            {bookingPerson?.payment_mode ===
                              "Piece Rate Method" && (
                                <>
                                  <div className="col-sm-4 mb-3">
                                    <p className="text-sm">Total Pieces</p>
                                    <h6>{bookingPerson.total_pieces}</h6>
                                  </div>
                                  <div className="col-sm-4 mb-3">
                                    <p className="text-sm">Pieces Price</p>
                                    <h6>{bookingPerson.piece_value}</h6>
                                  </div>
                                </>
                              )}
                            {bookingPerson?.payment_mode ===
                              "Invoice Value Method" && (
                                <>
                                  <div className="col-sm-4 mb-3">
                                    <p className="text-sm">Invoice Value</p>
                                    <h6>{bookingPerson.invoice_value}</h6>
                                  </div>
                                  <div className="col-sm-4 mb-3">
                                    <p className="text-sm">Invoice Percentage</p>
                                    <h6>{bookingPerson.invoice_percentage}%</h6>
                                  </div>
                                </>
                              )}
                          </div>
                        ) : (
                          <div>
                            <div className="row mb-3">
                              <div className="col-sm-4 mb-3">
                                <p className="text-sm">Large Box Quantity</p>
                                <h6>{bookingPerson.large_box_quantity}</h6>
                              </div>
                              <div className="col-sm-4 mb-3">
                                <p className="text-sm">Medium Box Quantity</p>
                                <h6>{bookingPerson.medium_box_quantity}</h6>
                              </div>
                              <div className="col-sm-4 mb-3">
                                <p className="text-sm">Small Box Quantity</p>
                                <h6>{bookingPerson.small_box_quantity}</h6>
                              </div>
                            </div>
                            <div className="row mb-3">
                              {bookingPerson?.payment_mode ===
                                "split booking" && (
                                  <>
                                    <div className="col-sm-4 mb-3">
                                      <p className="text-sm">Large Unit Price</p>
                                      <h6>{bookingPerson.large_unit_price}</h6>
                                    </div>
                                    <div className="col-sm-4 mb-3">
                                      <p className="text-sm">Medium Unit Price</p>
                                      <h6>{bookingPerson.medium_unit_price}</h6>
                                    </div>
                                    <div className="col-sm-4 mb-3">
                                      <p className="text-sm">Small Unit Price</p>
                                      <h6>{bookingPerson.small_unit_price}</h6>
                                    </div>
                                  </>
                                )}
                              {bookingPerson?.payment_mode ===
                                "CBM Rate Method" && (
                                  <>
                                    <div className="col-sm-4 mb-3">
                                      <p className="text-sm">CBM Quantity</p>
                                      <h6>{bookingPerson.cbm_value}</h6>
                                    </div>
                                    <div className="col-sm-4 mb-3">
                                      <p className="text-sm">CBM Price</p>
                                      <h6>{bookingPerson.total_cbm_price}</h6>
                                    </div>
                                  </>
                                )}
                              {bookingPerson?.payment_mode ===
                                "Piece Rate Method" && (
                                  <>
                                    <div className="col-sm-4 mb-3">
                                      <p className="text-sm">Total Pieces</p>
                                      <h6>{bookingPerson.total_pieces}</h6>
                                    </div>
                                    <div className="col-sm-4 mb-3">
                                      <p className="text-sm">Pieces Price</p>
                                      <h6>{bookingPerson.piece_value}</h6>
                                    </div>
                                  </>
                                )}
                              {bookingPerson?.payment_mode ===
                                "Invoice Value Method" && (
                                  <>
                                    <div className="col-sm-4 mb-3">
                                      <p className="text-sm">Invoice Value</p>
                                      <h6>{bookingPerson.invoice_value}</h6>
                                    </div>
                                    <div className="col-sm-4 mb-3">
                                      <p className="text-sm">
                                        Invoice Percentage
                                      </p>
                                      <h6>{bookingPerson.invoice_percentage}%</h6>
                                    </div>
                                  </>
                                )}
                            </div>
                          </div>
                        )}

                        <div className="row">
                          <div className="col-sm-4 mb-3">
                            <p className="text-sm">Note</p>
                            <h6>{bookingPerson.notes || 'N/A'}</h6>
                          </div>
                          <div className="col-sm-4 mb-3 text-start">
                            <p className="text-sm">Total Price</p>
                            <h6>{bookingPerson?.booking_value}</h6>
                          </div>
                        </div>
                      </div>
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      )}

      {isEditModalOpen && selectedBooking && (
        <BookingEdit
          booking={selectedBooking}
          onClose={() => setIsEditModalOpen(false)}
          onUpdateSuccess={() => {
            fetchBookings({}); // Call fetchBookings here
          }}
        />
      )}

      {showSplitsPopup && selectedSplits && (
        <div className="modal-backdrop shadow-lg rounded-5">
          <div className="modal fade show d-block" tabIndex={-1} role="dialog">
            <div
              className="modal-dialog modal-dialog-centered modal-xl"
              role="document"
              style={{ maxWidth: "80vw", height: "85%", margin: 'auto' }}
            >
              <div className="modal-content pb-10 pt-4">
                <div className="modal-header py-2 d-flex justify-content-end">
                  <button
                    type="button"
                    className="btn-close mb-3"
                    onClick={handleCloseSplitsPopup}
                  ></button>
                </div>
                <div
                  className="modal-body"
                  style={{ overflow: "auto", height: "400px" }}
                >
                  <div className="d-flex flex-column flex-md-row align-items-center mb-3">
                    <p className="modal-title text-center me-2 mb-2 mb-md-0">
                      Splits for Booking ID:
                    </p>
                    <h5
                      className="text-center mb-0 text-md-start"
                      style={{
                        wordBreak: "break-word",
                        whiteSpace: "pre-line",
                      }}
                    >
                      {selectedSplits[0]?.main_booking_id.replace(
                        /-(\d+)$/,
                        "\n-$1"
                      )}
                    </h5>
                  </div>

                  <div className="table-responsive w-100">
                    <table className="table table-striped mt-4 text-center">
                      <thead className="table-dark">
                        <tr className="fw-bolder">
                          <th className="min-w-120px text-break">Split ID</th>
                          <th className="min-w-100px text-break d-none d-md-table-cell">
                            Shipment ID
                          </th>
                          <th className="min-w-100px text-break d-none d-lg-table-cell">
                            Split Created
                          </th>
                          <th className="min-w-120px text-break">Consignor</th>
                          <th className="min-w-80px text-break">
                            <span className="d-none d-sm-inline">Total </span>Qty
                          </th>
                          <th className="min-w-80px text-break d-none d-md-table-cell">
                            <span className="d-none d-lg-inline">Small </span>S
                          </th>
                          <th className="min-w-80px text-break d-none d-md-table-cell">
                            <span className="d-none d-lg-inline">Medium </span>M
                          </th>
                          <th className="min-w-80px text-break d-none d-md-table-cell">
                            <span className="d-none d-lg-inline">Large </span>L
                          </th>
                          <th className="min-w-100px text-break">
                            <span className="d-none d-sm-inline">Total </span>Price
                          </th>
                          <th className="min-w-100px text-break">Status</th>
                        </tr>
                      </thead>
                      <tbody>
                        {selectedSplits?.map((split, index) => (
                          <tr key={index}>
                            <td>
                              {split.split_id.replace(/-(\d+)$/, "\n-$1")}
                            </td>
                            <td className="d-none text-center d-md-table-cell">
                              <span
                                style={{ maxWidth: "100px" }}
                                title={split.shipment_id || "N/A"}
                              >
                                {split.shipment_id || "N/A"}
                              </span>
                            </td>
                            <td className="d-none d-lg-table-cell">
                              <small>
                                {moment(split?.created_at).format("DD-MM-YYYY")}
                              </small>
                            </td>
                            <td title={split.consignor} style={{ cursor: 'pointer', maxWidth: '120px', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
                              {split.consignor}
                            </td>
                            <td>
                              <div className="d-flex align-items-center justify-content-center">
                                <i
                                  className="bi bi-box me-1"
                                  style={{ color: "blue", fontSize: "0.8rem" }}
                                ></i>
                                <span style={{ fontSize: "0.9rem" }}>
                                  {split.total_quantity}
                                </span>
                              </div>
                            </td>
                            <td className="d-none d-md-table-cell">
                              <div className="d-flex align-items-center justify-content-center">
                                <i
                                  className="bi bi-box me-1"
                                  style={{ color: "green", fontSize: "0.8rem" }}
                                ></i>
                                <span style={{ fontSize: "0.85rem" }}>
                                  {split.small_journey_quantity ||
                                    split.small_box_quantity}
                                </span>
                              </div>
                            </td>
                            <td className="d-none d-md-table-cell">
                              <div className="d-flex align-items-center justify-content-center">
                                <i
                                  className="bi bi-box me-1"
                                  style={{ color: "green", fontSize: "0.8rem" }}
                                ></i>
                                <span style={{ fontSize: "0.85rem" }}>
                                  {split.medium_journey_quantity ||
                                    split.medium_box_quantity}
                                </span>
                              </div>
                            </td>
                            <td className="d-none d-md-table-cell">
                              <div className="d-flex align-items-center justify-content-center">
                                <i
                                  className="bi bi-box me-1"
                                  style={{ color: "green", fontSize: "0.8rem" }}
                                ></i>
                                <span style={{ fontSize: "0.85rem" }}>
                                  {split.large_journey_quantity ||
                                    split.large_box_quantity}
                                </span>
                              </div>
                            </td>
                            <td>
                              <div className="d-flex align-items-center justify-content-center">
                                <i
                                  className="bi bi-currency-dollar me-1"
                                  style={{ color: "green", fontSize: "0.8rem" }}
                                ></i>
                                <span style={{ fontSize: "0.9rem" }}>
                                  {split.booking_value || "0.00"}
                                </span>
                              </div>
                            </td>
                            <td>
                              <span
                                className={`${getSplitBadgeClass(
                                  split.shipment_status
                                )} d-inline-block`}
                                style={{
                                  fontSize: "0.75rem",
                                  maxWidth: "80px",
                                  overflow: "hidden",
                                  textOverflow: "ellipsis",
                                  whiteSpace: "nowrap"
                                }}
                                title={split.shipment_status === "Shipment Started"
                                  ? "In Transit"
                                  : split.shipment_status}
                              >
                                {split.shipment_status === "Shipment Started"
                                  ? "In Transit"
                                  : split.shipment_status}
                              </span>
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>

                </div>
              </div>
            </div>
          </div>
        </div>
      )}

      {showDeleteConfirmationMessage && (
        <div className="modal-backdrop shadow-lg rounded-5">
          <div className="modal d-block" tabIndex={-1} role="dialog">
            <div className="modal-dialog modal-dialog-centered" role="document">
              <div className="modal-content pb-10 pt-4">
                <div className="modal-header py-2 d-flex justify-content-end">
                  <span
                    className="close-btn"
                    onClick={() => setShowDeleteConfirmationMessage(false)}
                  >
                    🗙
                  </span>
                </div>
                <div className="notice d-flex flex-column align-items-center p-6">
                  <div>
                    <KTSVG
                      path="/media/icons/duotune/general/gen044.svg"
                      className="svg-icon-2tx svg-icon-warning me-4"
                    />
                  </div>
                  <div className="d-flex flex-column align-items-center">
                    <h4>Are you sure you want to delete this Booking?</h4>
                    <div className="mt-4">
                      <button
                        className="btn btn-danger me-3"
                        onClick={confirmDeleteBooking}
                        disabled={isConfirmDeleting}
                      >
                        {!isConfirmDeleting && (
                          <span className="indicator-label">Confirm</span>
                        )}
                        {isConfirmDeleting && (
                          <span
                            className="indicator-progress"
                            style={{ display: "block" }}
                          >
                            Deleting...
                            <span className="spinner-border spinner-border-sm align-middle ms-2"></span>
                          </span>
                        )}
                      </button>
                      <button
                        className="btn btn-secondary"
                        onClick={() => {
                          setShowDeleteConfirmationMessage(false);
                          setBookingToDeleteId(null);
                        }}
                      >
                        Cancel
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}

      {showReturnConfirmationMessage && (
        <div className="modal-backdrop shadow-lg rounded-5">
          <div className="modal d-block" tabIndex={-1} role="dialog">
            <div className="modal-dialog modal-dialog-centered" role="document">
              <div className="modal-content pb-10 pt-4">
                <div className="modal-header py-2 d-flex justify-content-end">
                  <span
                    className="close-btn"
                    onClick={() => setShowReturnConfirmationMessage(false)}
                  >
                    🗙
                  </span>
                </div>
                <div className="notice d-flex flex-column align-items-center p-6">
                  <div>
                    <KTSVG
                      path="/media/icons/duotune/general/gen044.svg"
                      className="svg-icon-2tx svg-icon-warning me-4"
                    />
                  </div>
                  <div className="d-flex flex-column align-items-center">
                    <h4>Are you sure you want to Return this Booking?</h4>
                    <div className="mt-4">
                      <button
                        className="btn btn-danger me-3"
                        onClick={confirmReturnBooking}
                        disabled={isConfirmReturn}
                      >
                        {!isConfirmReturn && (
                          <span className="indicator-label">Confirm</span>
                        )}
                        {isConfirmReturn && (
                          <span
                            className="indicator-progress"
                            style={{ display: "block" }}
                          >
                            Returning...
                            <span className="spinner-border spinner-border-sm align-middle ms-2"></span>
                          </span>
                        )}
                      </button>
                      <button
                        className="btn btn-secondary"
                        onClick={() => {
                          setShowReturnConfirmationMessage(false);
                          setBookingToReturnId(null);
                        }}
                      >
                        Cancel
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export { BookingTable };
